import { FC } from 'react';

const RedDot: FC = () => {
  return (
    <>
      <div style={{ background: '#FF1111', height: 8, width: 8, borderRadius: '50%' }}></div>
    </>
  );
};

export default RedDot;
